/**
 * ContactForm — modal simples para USER submeter mensagem ao admin.
 * Alcance limitado ao role `user` (admin/staff usam gestão direta na BD).
 * Backend: POST /api/support/message (autenticado, qualquer role).
 */
import React, { useState } from 'react';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { Mail } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const ContactForm = () => {
  const [open, setOpen] = useState(false);
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!subject.trim() || !message.trim()) {
      toast.error('Preenche o assunto e a mensagem');
      return;
    }
    setBusy(true);
    try {
      await axios.post(`${API}/support/message`, { subject, message }, { withCredentials: true });
      toast.success('Mensagem enviada ao suporte Tectur');
      setSubject(''); setMessage(''); setOpen(false);
    } catch (e) {
      const status = e?.response?.status;
      const detail = e?.response?.data?.detail || e?.message || 'sem detalhe';
      toast.error(`Falha a enviar (${status || 'network'}): ${detail}`);
      console.error('ContactForm submit error:', status, e?.response?.data);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="ghost" size="sm" data-testid="contact-form-btn" title="Reportar / Contactar Tectur">
          <Mail className="h-4 w-4" />
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-md" data-testid="contact-form-modal">
        <DialogHeader>
          <DialogTitle>Contactar Suporte Tectur</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <Label htmlFor="cf-subject">Assunto</Label>
            <Input id="cf-subject" value={subject} onChange={(e) => setSubject(e.target.value)} placeholder="Ex: Bug no download de mapas" data-testid="contact-subject" maxLength={200} />
          </div>
          <div>
            <Label htmlFor="cf-message">Mensagem</Label>
            <Textarea id="cf-message" value={message} onChange={(e) => setMessage(e.target.value)} rows={6} placeholder="Descreve o que precisas..." data-testid="contact-message" maxLength={5000} />
          </div>
          <p className="text-xs text-muted-foreground">
            A mensagem chega directamente a <strong>tectur@tectur.pt</strong>. Respondemos em 48h.
          </p>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => setOpen(false)} disabled={busy}>Cancelar</Button>
          <Button onClick={submit} disabled={busy} data-testid="contact-submit">
            {busy ? 'A enviar…' : 'Enviar'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ContactForm;
